import { useEffect } from "react";
import { useHistory, useParams } from "react-router";
import { useDispatch } from "react-redux";
import { Page } from "@common-ui/ui";
import { Container } from "@mui/material";
import { Header } from "../../components";
import SummaryDownload from "../../components/SummaryDownload";
import { getOrgWorkEvent } from "../../services";
import { workEventSlice } from "../../reducers/workEventReducer";

const SummaryReportDownload = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  let { id, orgId } = useParams();

  const getWorkEvent = async () => {
    try {
      const workEventData = await getOrgWorkEvent(orgId, id);
      dispatch(workEventSlice.actions.setWorkEvent(workEventData.data));
    } catch (e) {}
  };

  useEffect(() => {
    getWorkEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title="FlukeWorks" sx={{ background: "#F5F5F5" }}>
      <Header xl name="Summary Report" history={history} />
      <Container maxWidth="xl" component="main" sx={{ my: 2 }}>
        <SummaryDownload orgId={orgId} eventId={id} />
      </Container>
    </Page>
  );
};

export default SummaryReportDownload;
